import { render, staticRenderFns } from "./DashboardCollapsibleCard.vue?vue&type=template&id=0e861530"
import script from "./DashboardCollapsibleCard.vue?vue&type=script&lang=js"
export * from "./DashboardCollapsibleCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports